module.exports = __webpack_public_path__ + "static/media/LoginPanel.65e99480.png";